import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateChildFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const keycloak = inject(KeycloakService);

  if (environment.bypassAuth) {
    console.warn('Authentication bypassed - for development only!');
    return true;
  }

  const authenticated = await keycloak.isLoggedIn();

  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  const requiredRoles = route.data['roles'];
  if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
    return true;
  }

  const userRoles = keycloak.getUserRoles();
  const hasRequiredRoles = requiredRoles.every((role: string) => userRoles.includes(role));

  if (!hasRequiredRoles) {
    await router.navigate(['/']);
    return false;
  }

  return true;
};
